<template>
  <div class="scheme">
    <BaseDialog title="历史导入" :isshow="visible" @handleShow="(val) => {
      visible = val
    }" height="auto" width="auto">
      <div class="schemeBox">
        <div class="scheme-left">
          <div class="leftTable">
            <div class="tables">
              <el-table size="small" v-loading="loading" :data="tableData" @row-click="rowclick" stripe
                style="min-width: 100%" border>
                <el-table-column prop="date" label="时间" width="120" />
                <el-table-column prop="total_fee" label="费用" width="80" />
              </el-table>
            </div>
          </div>
          <div class="rigthc_table">
            <!-- 顶部 -->
            <!-- 表格 -->
            <div class="tables">
              <el-table size="small" :data="rightableData" stripe max-height="400px" border
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center" :selectable="handleSelectable">
                </el-table-column>
                <el-table-column width="250" property="advice_drug" label="名称" show-overflow-tooltip />
                <el-table-column width="120" property="drug.company" label="厂家" show-overflow-tooltip />
                <el-table-column width="60" property="num" label="数量" align="center" />
                <el-table-column width="60" prop="num_unit_name" label="单位" align="center" />
                <el-table-column property="sell_price" label="售价" />
                <el-table-column property="drug.is_enable" label="状态">
                  <template #default="scope">
                    <el-tag v-if="scope.row.drug.is_enable == 1">在用</el-tag>
                    <el-tag v-else type="danger">停用</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visible = false">
            取消
          </el-button>
          <el-button class="color-determine" type="primary" :loading="saveLoad" @click="saveLongItem">
            导入
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick } from 'vue'
import service from '@/utils/request'
import Rule from '@/utils/rule'
import { gitDictList, ruleTimeYear } from '@/utils/tool'
import { ElMessage } from 'element-plus'
import BaseDialog from '@/components/Dialog/index.vue'
export default {
  name: 'dialysisScheme',
  components: {
    BaseDialog,
  },
  props: ['patientId', 'recordId'],
  emits: ['refreshDataList'],
  setup(props, ctx) {
    const state = reactive({
      visible: false,
      Dialoading: false,
      currenting: 1,
      loading: false,
      saveLoad: false,
      contLoading: false,
      ruleForm1Ref: null,
      ruleForm: {},
      sid: null,
      total: 0,
      tableData: [],
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalSum: 0,
      },
      rightableData: [],
      type: '',//临时，长期
      recordId: '',
      tableSelected: []
    })

    const initData = async (patientData) => {
      state.type = patientData
      state.recordId = patientData.record_id
      console.log(state.type)
      formInit()
      state.visible = true
      tobody()
    }

    onMounted(() => {

    })
    // 获取左侧列表
    const tobody = async () => {
      state.loading = true
      let data = {
        // patient_id: 70,
        patient_id: state.type.patient_id,
      }
      let res = await service.post('/api/dialysis_record/getPatientRecordList', data)
      if (res.code === 0) {
        state.loading = false
        if (res.data.record_list.length > 0) {
          state.tableData = res.data.record_list
          state.sid = res.data.record_list[0].id
          rightbody(res.data.record_list[0].id)
        } else {
          state.tableData = []
        }
      }
    }
    // 左侧页数改变时
    const currentings = (e) => {
      console.log('页面', e)
      state.currenting = e
      tobody()
    }
    //添加颜色
    const rowStyle = (row) => {
      if (state.sid === row.row.id) {
        return { 'background-color': '#ccc', cursor: 'pointer', 'color': '#333' };
      }
      return { cursor: 'pointer' };
    }
    // 左侧列表点击
    const rowclick = (row) => {
      state.sid = row.id
      rightbody(row.id)
    }
    // 右侧表格列表
    const rightbody = async (id) => {
      state.Dialoading = true
      let data = {
        dialysis_record_id: id,
        current: 1,
        size: 9999,
      }
      let res = await service.post('/api/dialysis_record/getHistoryRecordAdvice', data)
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.rightableData = res.data.records
        } else {
          state.rightableData = []
        }
      }
      state.Dialoading = false
    }
    const formInit = () => {
      state.ruleForm = {}
    }
    // 复选框
    const handleSelectionChange = (e) => {
      state.tableSelected = e
      // if (e.length > 0) {
      //   e.forEach(item1 => {
      //     if (!state.tableSelected.some(item2 => item2.id == item1.id)) {
      //       state.tableSelected.push(item1)
      //     }
      //   })
      // } else {
      //   state.rightableData.forEach((item1, index1) => {
      //     let findIndex = state.tableSelected.findIndex(item2 => item2.id == item1.id)
      //     if (findIndex > -1) {
      //       state.tableSelected.splice(findIndex, 1)
      //     }
      //   })
      // }
      // console.log(state.tableSelected)
    }
    const handleSelectable = (e) => {
      return e.drug.is_enable == 1
    }
    const saveLongItem = async () => {
      state.ruleForm.advice_temp_ids = state.tableSelected.map(item => { return item.id })
      state.saveLoad = true
      let res = {}
      state.ruleForm.record_id = state.type.record_id
      state.ruleForm.patient_id = state.type.patient_id
      res = await service.post(
        '/api/dialysis_record/createTempAdviceByTempIds',
        state.ruleForm
      )
      
      if (res.code === 0) {
        state.saveLoad = false
        state.tableSelected = []
        ElMessage.success(res.msg)
        if (!state.continuous) {
          state.visible = false
        }
        ctx.emit('refreshDataList')
      }else{
        state.saveLoad = false
      }
    }

    return {
      ...toRefs(state),
      initData,
      tobody,
      saveLongItem,
      rightbody,
      rowclick,
      rowStyle,
      formInit,
      handleSelectionChange,
      handleSelectable,
      currentings
    }
  },
}
</script>

<style scoped lang="scss">
.el-input {
  width: 214px;
  // margin-right: 62px;
}

.schemeBox {
  margin-top: 10px;
}

.scheme-left {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .leftTable {
    margin-right: 10px;
  }
}

.demo-Form {
  margin-top: 0;

  .el-form-item {
    width: 100%;
  }

  &:deep(.el-form-item__content) {
    // width: calc(100% - 260px);
    font-size: 14px;
    font-family: 'Source Han Sans CN-Regular';
    color: #444444;
  }

  &:deep(.el-form-item .el-input) {
    width: 120px;
    margin-right: 2px;
  }
}

.scheme-tag {
  background: rgba(49, 102, 174, 0.1);
  border-radius: 8px;
  padding: 4px 20px;
  padding-bottom: 0;
  margin: 16px 0;

  .name {
    font-size: 14px;
    color: #3166ae;
  }

  .el-tag {
    margin-bottom: 4px;
  }
}

.scheme-cont {
  padding: 0 10px;
  margin-top: 20px;
  border-right: 1px solid #e0e0e0;
  height: 310px;
  padding-left: 0;

  .item {
    height: 32px;
    line-height: 32px;
    width: 100%;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Medium';
    color: #444444;
    padding-right: 14px;
    margin-bottom: 12px;

    .lable {
      background-color: #ffffff;
      border-radius: 4px;
      padding-left: 20px;
      cursor: pointer;
    }

    &.active {
      border-right: 4px solid #3166ae;

      .lable {
        background-color: rgba(49, 102, 174, 0.3);
        color: #3166ae;
      }
    }

    &:hover {
      .lable {
        background-color: rgba(49, 102, 174, 0.3);
        color: #3166ae;
      }
    }
  }
}

.scheme-right {
  width: 444px;

  .fa {
    color: #3166ae;
    margin-left: 12px;
  }

  .fixedDate {
    .el-radio {
      margin-right: 126px;

      &:last-child {
        margin-right: 0;
      }
    }

    .el-alert {
      margin: 10px 0 20px;
      color: #ff3e3e;
    }

    .el-checkbox {
      margin-right: 126px;
      margin-bottom: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 18px;
    margin-right: 0;

    .fa {
      font-size: 22px;
    }

    &.icon {
      &:deep(.el-input) {
        width: 232px;
        margin-right: 0;
      }
    }
  }

  &:deep(.el-radio-group.height-40 .el-radio-button__inner) {
    padding: 12px 26px;
  }

  &:deep(.el-input),
  &:deep(.el-form .el-form-item__content .el-date-editor.el-input) {
    width: 264px;
  }

  &:deep(.el-input-group__append .el-input) {
    width: 80px;
  }

  &:deep(.el-textarea) {
    width: 338px;
  }
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;

  .color-cancel {
    background: #ffffff;
    color: #3166ae;
    margin-right: 10px;
  }
}
</style>